import styled from "styled-components";

export const ServiceTableStyled = styled.div`
  padding: 12px 36px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  .buttonContainer {
    display: flex;
    justify-content: end;
  }
`;
